import React from "react";
import { createRoot } from "react-dom/client";
import Manage from "./Manage/index";

const root = createRoot(document.getElementById("hosts-detail"));
if (root) root.render(<Manage />);
